module.exports = __webpack_public_path__ + "img/index-exam@2x.1be5a1d6.png";